<template>
  <v-container fluid>
    <h2 class="mb-5">表示設定</h2>

    <v-row no-gutters>
      <v-col :cols="$vuetify.display.mobile ? 12 : 3" v-if="!$vuetify.display.mobile || configKind.length == 0">
        <v-card>
          <v-card-text>
            <v-list nav class="pa-0" v-model:selected="configKind">

              <v-list-subheader>
                ご利用中の端末の設定
              </v-list-subheader>

              <v-list-item value="tiles">
                <v-list-item-title>タイル表示</v-list-item-title>
                <template v-slot:append>
                  <v-icon>mdi-chevron-right</v-icon>
                </template>
              </v-list-item>

              <v-list-item value="chart-areas" v-if="!$vuetify.display.mobile">
                <v-list-item-title>グラフ表示</v-list-item-title>
                <template v-slot:append>
                  <v-icon>mdi-chevron-right</v-icon>
                </template>
              </v-list-item>

              <v-divider class="my-2"></v-divider>

              <v-list-subheader>
                テンプレート
              </v-list-subheader>

              <v-list-item value="tiles-template">
                <v-list-item-title>タイル表示</v-list-item-title>
                <template v-slot:append>
                  <v-icon>mdi-chevron-right</v-icon>
                </template>
              </v-list-item>

              <v-list-item value="chart-areas-template" v-if="!$vuetify.display.mobile">
                <v-list-item-title>グラフ表示</v-list-item-title>
                <template v-slot:append>
                  <v-icon>mdi-chevron-right</v-icon>
                </template>
              </v-list-item>

              <v-divider class="my-2"></v-divider>

              <v-list-subheader>
                モジュールごとの設定
              </v-list-subheader>

              <v-list-item value="stopped-indication-criteria">
                <v-list-item-title>停止表示判定</v-list-item-title>
                <template v-slot:append>
                  <v-icon>mdi-chevron-right</v-icon>
                </template>
              </v-list-item>

            </v-list>
          </v-card-text>
        </v-card>
      </v-col>

      <v-col :cols="$vuetify.display.mobile ? 12 : 9" v-if="configKind.length >= 1">
        <v-card :class="{ 'ms-3': !$vuetify.display.mobile }">
          <v-card-text>
            <v-btn variant="text" color="primary" prepend-icon="mdi-chevron-left" class="mb-3"
              v-on:click="() => { configKind = [] }" v-if="$vuetify.display.mobile">
              設定項目の選択に戻る
            </v-btn>

            <component :is="Components[configKind[0]]" />
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { ref, shallowRef } from 'vue';

import TileViewSetting from '../components/TileViewSetting.vue';
import ChartViewSetting from '../components/ChartViewSetting.vue';

import TileViewTemplateSetting from '../components/TileViewTemplateSetting.vue';
import ChartViewTemplateSetting from '../components/ChartViewTemplateSetting.vue';

import StoppedIndicationCriteriaSetting from '../components/StoppedIndicationCriteriaSetting.vue';

export default {
  name: 'MonitorEditView',

  setup() {

    const configKind = ref([]);

    const Components = shallowRef({
      'tiles': TileViewSetting,
      'chart-areas': ChartViewSetting,

      'tiles-template': TileViewTemplateSetting,
      'chart-areas-template': ChartViewTemplateSetting,

      'stopped-indication-criteria': StoppedIndicationCriteriaSetting
    });

    return {
      configKind,
      Components
    }

  }
}
</script>
